import React, { useState, FC } from 'react';
import styled from 'styled-components';
import App from '../../../models/app';
import {
  ContentBlock,
  SectionTitle
} from 'components/v2/Common';
import Device from '../Device';
import ImageContainer from '../ImageContainer/index';
import { calculateHeight } from '../../../utils.v2';

interface AppScreenshotCarouselProps {
  app: App;
  screenshotsSectionTitle?: string;
  deviceName?: string;
  borderTop?: boolean;
  borderBottom?: boolean;
  premiumIcon?: string;
}

const DeviceBanners = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const DeviceBanner = styled(ImageContainer)`
  padding: 10px;
  margin-top: 25px;
  border-radius: 6px;
  width: 56px;
  cursor: pointer;
  height: ${(props) => props.bannerHeight}px;
`;

const AppScreenshotCarousel: FC<AppScreenshotCarouselProps> = (props) => {
  const [ state, updateState ] = useState({ selectedBanner: props.app.banners[0] })

  return(
    <React.Fragment>
      {props.screenshotsSectionTitle &&
        <SectionTitle>{props.screenshotsSectionTitle}</SectionTitle>}
      <ContentBlock borderTop={props.borderTop} borderBottom={props.borderBottom}>
        <Device
          deviceName={props.deviceName}
          premiumIcon={props.premiumIcon}
          image={state.selectedBanner}
          preloadDeviceImage={false}
        />
        <DeviceBanners>
          { props.app.banners.length > 1 &&
            props.app.banners.map((banner, index) => {
                let bannerHeight = calculateHeight(banner.height, banner.width);
                return (
                  <DeviceBanner
                    containerAttr={{
                      width: 56,
                      height: bannerHeight,
                    } as any}
                    imageAttr={{
                      src: banner.uri,
                    }}
                    onClick={() => updateState({ selectedBanner: banner })}
                    key={`DeviceBanner_${index}`}
                    id={`DeviceBanner_${index}`}
                    aria-label={`DeviceBanner_${index}`}
                    bannerHeight={bannerHeight}
                  />
                )
              }
            )
          }
        </DeviceBanners>
      </ContentBlock>
    </React.Fragment>
  )
};

export default AppScreenshotCarousel;
